/*
 File: instream-ad.js
 Author: D McCleod
 Created: 03/24/2019
 Description: insert instream ads to infinite slideshows, based on Target Testing variable
 */

import { infiniteScrollTracking } from './infinitescroll-tracking';
import { configObj } from './config';

const instreamAd = {
     init: function(target) {
        let targetString = typeof parseInt(target) !== 0 ? `${target}slides` : 'default';
        this.targetValue =  `cr2019_${targetString}`;
        this.targetKey = 'tex';
        this.addClass = 'instream-ad';
        this.loadedClass = 'ad-loaded';
        this.timer = null;
        this.adArray = [];
        this.insertContainers(target);
        this.windowHeight = $(window).height();
        this.allSlides = Array.from(infiniteScrollTracking.slideDivs);
        let that = this, trackScroll = null;
        $(window).on('scroll', () => {
             clearTimeout(trackScroll);
             trackScroll = setTimeout(function() {
                 that.addLazyLoadedAds();
             }, 250);
         });
     },

     insertContainers: function(target) {
         this.slidesArray = $(configObj.slide).each((i, slide) => {
            let integer = (i+1) / target;
            let isWhole = integer % 1 === 0;
            if(isWhole) {
                const ad = document.createElement('div');
                ad.id = `instream-${i+1}`;
                ad.classList.add(this.addClass);
                ad.setAttribute('data-index', i+1);
                $(ad).insertAfter(slide);
                this.adArray.push(ad);
            }
         });

         return this.slidesArray;
     },

     addLazyLoadedAds: function() {
         let slidesInView = this.allSlides.filter((s) => {
             // possible that more than one slide is in the viewport at one time
             return this.isInViewport(s);
         });
         console.log(slidesInView);
         let visibleAd = this.adArray.filter(ad => {
             return slidesInView.filter((s) => {
                 return ad.dataset.index === s.dataset.slidenumber;
             }).length > 0;
         })[0];

        // do not refresh an add that has already loaded or is a blank ad
        if(visibleAd) {
            if (!visibleAd.classList.contains(this.loadedClass) && !visibleAd.classList.contains('blank-ad')) {
                visibleAd.classList.add(this.loadedClass, 'AdUnit');
                webmd.ads2.defineAd({
                    id: visibleAd.id,
                    pos: 1122,
                    collapseAfter: true,
                    display: false
                });
                webmd.ads2.refresh({ id: visibleAd.id });
                webmd.ads2.display();
            }
        }
        return visibleAd;
     },

    isInViewport: function(el) {
        // https://codepen.io/bfintal/pen/Ejvgrp
        const scroll = window.scrollY || window.pageYOffset;
        const boundsTop = el.getBoundingClientRect().top + scroll;
        const viewport = {
            top: scroll,
            bottom: scroll + window.innerHeight,
        };
        const bounds = {
            top: boundsTop,
            bottom: boundsTop + el.clientHeight,
        };

        return ( bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom )
            || ( bounds.top <= viewport.bottom && bounds.top >= viewport.top );
    }
};

 export { instreamAd };